// "Get directions" links. Pure, so vitest covers it.
//
// Both the map panel and the artwork page need this URL, and the page used to
// read a `flagLink` field that the API stopped sending when the static mocks
// were removed, leaving the link dead. One helper, one source of truth.

const coord = value => {
  const n = typeof value === 'number' ? value : parseFloat(value)
  return Number.isFinite(n) ? n : null
}

/**
 * A Google Maps directions URL to `art`, or null when its coordinates are
 * unusable. Callers bind the null straight to `:href` so the browser drops
 * the attribute instead of offering a link that goes nowhere.
 */
export function directionsUrl(art) {
  if (!art) return null

  const lat = coord(art.lat)
  const lng = coord(art.lng)
  if (lat === null || lng === null) return null

  const destination = encodeURIComponent(`${lat},${lng}`)
  return `https://www.google.com/maps/dir/?api=1&destination=${destination}`
}
